import React from "react";
import AboutImg from "../assets/Images/aboutImg.png";

// Data
const carouselData = [
  {
    image: "./Images/banner1.png",
    title: "Step Arena Membership",
    description:
      "Unlimited use of Spa, pools, Fitness, and more. Plans tailored to your lifestyle and goals.",
    linkText: "JOIN US TODAY",
  },
  {
    image: "./Images/banner2.png",
    title: "Aqua Outdoor – Active Summers in Nature",
    description:
      "50 m Olympic pool, grandstands, children’s pool, and fresh air. Perfect for competitions, families, and outdoor recreation.",
    linkText: "READ MORE",
  },
  {
    image: "./Images/banner3.png",
    title: "Step Aqua Indoor – Training Without Seasons",
    description:
      "Modern pools for competitions, swim courses, and therapy. A comfortable and safe space for all ages.",
    linkText: "READ MORE",
  },
  {
    image: "./Images/banner4.png",
    title: "Stay & Savor – Step Hotel & Restaurant",
    description:
      "High-quality accommodation and healthy dining for athletes, teams, and families – all within the complex.",
    linkText: "READ MORE",
  },
  {
    image: "./Images/banner5.png",
    title: "Step Arena Membership",
    description:
      "Unlimited use of Spa, pools, Fitness, and more. Plans tailored to your lifestyle and goals.",
    linkText: "JOIN US TODAY",
  },
];

const SwimmingData = [
  {
    image: "./Images/swiming-activity1.png",
    title: "OUTDOOR",
  },
  {
    image: "./Images/swiming-activity2.png",
    title: "INDOOR",
  },
  {
    image: "./Images/swiming-activity3.png",
    title: "HOTEL & RESTURANT",
  },
  {
    image: "./Images/swiming-activity4.png",
    title: "EVENTS",
  },
];

const GalleryImages1 = [
  { images: "./Images/gallery1.png" },
  { images: "./Images/gallery2.png" },
  { images: "./Images/gallery3.png" },
  { images: "./Images/gallery4.png" },
];

const GalleryImages2 = [
  { images: "./Images/gallery5.png" },
  { images: "./Images/gallery6.png" },
  { images: "./Images/gallery1.png" },
  { images: "./Images/gallery5.png" },
];

const TestimonialData = [
  {
    names: "Ardian K.",
    description:
      "Stërvitem në Step Arena që nga hapja. Pishinat janë të standardeve ndërkombëtare dhe ambienti të motivon çdo ditë të japësh më të mirën.",
    image: "/Images/Ellipse1.png",
  },
  {
    names: "Albulena R.",
    description:
      "Për herë të parë ndjej që ka një vend në Prishtinë ku fëmijët mund të mësojnë not me siguri dhe ne prindërit të relaksohemi në të njëjtin vend.",
    image: "/Images/Ellipse2.png",
  },
  {
    names: "Valon T.",
    description:
      "Pas një operacioni në këmbë, terapia ujore në Step Spa më ndihmoi të rikthehem më shpejt se që kisha pritur.",
    image: "/Images/Ellipse3.png",
  },
  {
    names: "Elsa M.",
    description:
      "Shërbim i jashtëzakonshëm dhe kuzhinë e balancuar për ata që kujdesen për veten. E ndjej veten si në një resort modern jashtë qytetit.",
    image: "/Images/Ellipse4.png",
  },
];

const NewsData = [
  {
    title: '"Prishtina Open 2025" – International Swimming Competition',
    description:
      "Step Arena will host the region’s largest swimming event – “Prishtina Open”, featuring clubs from 10 European countries.",
    images: "./Images/competition1.png",
  },
  {
    title: '"Prishtina Open 2025" – International Swimming Competition',
    description:
      "Step Arena will host the region’s largest swimming event – “Prishtina Open”, featuring clubs from 10 European countries.",
    images: "./Images/competition2.png",
  },
  {
    title: '"Prishtina Open 2025" – International Swimming Competition',
    description:
      "Step Arena will host the region’s largest swimming event – “Prishtina Open”, featuring clubs from 10 European countries.",
    images: "./Images/competition3.png",
  },
];

const HOME = () => {
  return (
    <>
      {/* Carousel */}
      <div className="container-fluid px-0">
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">

          <div className="carousel-indicators">

            {carouselData.map((_, index) => (

              <button key={index} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={index === 0 ? "active" : ""} aria-current={index === 0 ? "true" : undefined} aria-label={`Slide ${index + 1}`}></button>
              
            ))}
          </div>

          <div className="carousel-inner avain">

            {carouselData.map((slide, index) => (

              <div className={`carousel-item ${index === 0 ? "active" : ""} carousel-container`} key={index} >

                <img src={slide.image} className="d-block w-100 img-fluid carousel-image" alt={slide.title} />
                <div className="carousel-caption text-white text-center">
                  <h3 className=" fw-bold my-0">{slide.title}</h3>
                  <p> {slide.description} </p>
                  <a href="#" className="btn btn-light btn-sm"> {slide.linkText} </a>
                </div>

              </div>

            ))}

          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* About Section */}
      <div className="container-fluid bg-primary">
        <div className="row align-items-center">

          <div className="col-12 col-lg-6 px-0">
            <img src={AboutImg} alt="" className="img-fluid w-100 h-100 object-fit-cover" />
          </div>

          <div className="col-12 col-lg-6 text-white p-3 p-md-5">

            <h3 className="fw-bold fs-4 fs-md-3"> Step Arena – More Than a Sports Center </h3>
            <p className="fs-6 fs-md-5"> Perched atop a peaceful, green hill, far from urban noise, Step Arena offers a unique experience that blends sports, relaxation, and wellness in a modern and inspiring environment. With Olympic-size pools, recovery facilities, a hotel, a restaurant,  and specialized programs, we serve athletes, families, and anyone seeking more from their time. </p>

            <span className="fw-bold d-block"> This is where champions are born </span>
            <span className="fw-bold d-block"> This is where minds are renewed. </span>
            <span className="fw-bold d-block">  This is where people connect. </span>

            <a href="#" className="btn btn-outline-light mt-3"> READ MORE ABOUT US </a>
          </div>

        </div>
      </div>

      {/* Swimming Activity */}
      <section className="container-fluid py-4">
        <div className="row">

          {SwimmingData.map((slide, index) => (

            <div key={index}className="col-6 col-lg-3 px-0 hover-effect"> 

              <img src={slide.image}alt=""className="w-100 img-fluid"/>
              <h2 className="content fs-5 fs-lg-4">{slide.title}</h2>
              <div className="hover-border"></div>

            </div>

          ))}

        </div>
      </section>

      {/* Gallery Details */}
      <div className="container my-4">
        <div className="row gallery-details-container align-items-center text-center">

          <div className="col-12 col-md-6">

            <h3 className="fs-5 fs-md-4 text-primary fw-bold pb-3"> Stay Updated with the Latest from Step Arena </h3>
            <p className="text-dark fs-6"> From international swimming competitions and youth summer camps
              to wellness events and new training programs – this section brings you the news that matters.  </p>

          </div>

          <div className="col-12 col-md-6 text-md-end mt-3 mt-md-0">
            <a href="#" className="btn btn-primary btn-sm"> READ MORE </a>
          </div>

        </div>
      </div>

      {/* Gallery Section */}
      <section className="container-fluid">

        {[GalleryImages1, GalleryImages2].map((galleryRow, rowIndex) => (

          <div key={rowIndex} className="row g-2 mb-2">

            {galleryRow.map((slide, index) => (

              <div key={index} className="col-6 col-md-3 p-1 d-flex gallery-control">
                <img src={slide.images} alt="" className="img-fluid w-100" />
              </div>

            ))}

          </div>

        ))}

      </section>

      {/* Testimonial Section */}
      <section className="container-fluid testimonial pb-5 bg-dark">
        <div className="container">
          <div className="row mb-5 testimonial-head text-white">
            <div className="col-md-5 p-3 p-md-5">
              <p className="mb-2">TESTIMONIALS</p>
              <h4 className="fs-5 fs-md-3 fw-bold">
                WHAT OUR VISITORS SAY
              </h4>
            </div>
            <div className="col-md-7 p-3 p-md-5">
              <p className="fs-6"> At Step Arena, every experience leaves a mark – and the words of those who trust us are the clearest proof of our quality and dedication.</p>
            </div>
          </div>

          <div className="row g-4">
            {TestimonialData.map((slide, index) => (

              <div className="col-12 col-lg-3 col-md-6 key={index}">

                <div className="testimonial-details text-center text-white p-3 h-100">

                  <i className="fa-solid fa-quote-right pb-3 fs-2"></i>
                  <p className="fs-6">{slide.description}</p>

                  <div className="my-4">

                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i}  className="fa-solid fa-star text-warning" ></i>
                    ))}

                  </div>

                  <div className="ellipse d-flex flex-column align-items-center">
                    <img  src={slide.image}  alt="" className="rounded-circle mb-2"/>
                    <h5 className="fs-6">{slide.names}</h5>
                  </div>

                </div>

              </div>

            ))}
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="news-section my-5">
        <div className="container">

          <div className="row news-details-container mb-4 text-center text-md-start">

            <div className="col-12 col-md-9">

              <h3 className="text-primary fw-bold pb-3 fs-5 fs-md-3"> Stay Updated with the Latest from Step Arena </h3>
              <p className="text-dark fs-6"> From international swimming competitions and youth summer camps
                to wellness events and new training programs – this section
                brings you the news that matters. </p>

            </div>

            <div className="col-12 col-md-3 text-md-end mt-3 mt-md-0">
              <a href="#" className="btn btn-primary btn-sm"> READ MORE </a>
            </div>

          </div>

          <div className="row">

            <div className="col-12 col-lg-6 px-0 competition-container mb-5 mb-lg-0">

              <img src="Images/competition-background.png" alt="" className="img-fluid w-100" />

              <div className="competition-data p-3 newsz-details shadow">
                <p className="fs-6">05, July 2025</p>
                <h5 className="text-primary fw-bold">  "Prishtina Open 2025" – International Swimming Competition </h5>
                <p className="fs-6"> Step Arena will host the region’s largest swimming event –
                  “Prishtina Open”, featuring clubs from 10 European countries. </p>
              </div>

            </div>

            <div className="col-12 col-lg-6 ps-lg-4 ps-0 d-flex flex-column justify-content-center">

              {NewsData.map((slide, index) => (

                <div className="row mb-5 mb-lg-3" key={index}>

                  <div className="col-12 col-md-4 px-0 mb-4 mb-lg-0">
                    <img src={slide.images} alt="" className="img-fluid w-100 h-100" />
                  </div>

                  <div className="col-12 col-md-8 px-4 newsz-details">
                    <p>05, July 2025</p>
                    <h5 className="text-primary fw-bold m-0"> {slide.title} </h5>
                    <p> {slide.description} </p>
                  </div>

                </div>

              ))}

            </div>
          </div>
 
        </div>
      </section>
    </>
  );
};

export default HOME;
